export default "__VITE_ASSET__DmvTWNUq__"